import {useEffect, useMemo, useState} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function OccurrenceNature({ data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const occurrenceNatureChart = useMemo(() => {
        const source = data?.occurrencesNatures || [];

        return {
            labels: source.map(item => ReportUtils.formatText(item.natures)),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.barChart(
            "occurrence-nature-chart",
            occurrenceNatureChart.values,
            occurrenceNatureChart.labels,
        );
    }, [occurrenceNatureChart]);

    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row">
                    <span className="chart-title">Naturezas das ocorrências</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id="occurrence-nature-chart"/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>
            <div className="chart-divisor"/>
        </>
    )
}